import React, { useState, useEffect } from 'react';
import { boolean, number, select, object, text } from '@storybook/addon-knobs';
import { Dropdown, Checkbox, TextInput, TextArea } from 'carbon-components-react';
import {
    Button,
    SelectItem,
    DatePicker,
    DatePickerInput,
    TimePicker,
    TimePickerSelect,
    ToggleSmall
} from 'carbon-components-react';
import { MultiSelect } from 'carbon-components-react';
import { action } from '@storybook/addon-actions';
import i18n from "../../i18n";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
require("./_basic-info.scss");
require("./_manage-schedule.scss");

const defaultLabel = 'MultiSelect Label';
const defaultPlaceholder = 'AppStack';

const types = {
    'Default (default)': 'default',
    'Inline (inline)': 'inline',
};
const props = () => ({
    id: text('MultiSelect ID (id)', 'appstack'),
    helperText: text('Helper text (helperText)', ''),
    disabled: boolean('Disabled (disabled)', false),
    light: boolean('Light variant (light)', false),
    useTitleInItem: boolean('Show tooltip on hover', false),
    type: select('UI type (Only for `<MultiSelect>`) (type)', types, 'default'),
    size: select('Field size (size)', sizes, undefined) || undefined,
    direction: select('Dropdown direction (direction)', directions, 'bottom'),
    label: text('Label (label)', 'AppStack'),
    warn: boolean('Show warning state (warn)', false),
    warnText: text(
        'Warning state text (warnText)',
        'Selecting more items may increase processing time'
    ),
    onChange: action('onChange'),
    onMenuChange: action('onMenuChange'),
    listBoxMenuIconTranslationIds: object(
        'Listbox menu icon translation IDs (for translateWithId callback)',
        {
            'close.menu': 'Close menu',
            'open.menu': 'Open menu',
            'clear.all': 'Clear all',
            'clear.selection': 'Clear selection',
        }
    ),
    selectionFeedback: select(
        'Selection feedback',
        ['top', 'fixed', 'top-after-reopen'],
        'top-after-reopen'
    ),
});


const sizes = {
    'Extra large size (xl)': 'xl',
    'Default size': undefined,
    'Small size (sm)': 'sm',
};

const directions = {
    'Bottom (default)': 'bottom',
    'Top ': 'top',
};


const {
    listBoxMenuIconTranslationIds,
    selectionFeedback,
    ...multiSelectProps
} = props();

export const BasicInfo = props => {
    let user = JSON.parse(localStorage.getItem('user'));

    const ScheduleName = i18n.t('manageschedule.ScheduleName')
    const descriptionPlaceholder = i18n.t('manageschedule.descriptionPlaceholder')
    const labelTextDescription = i18n.t('manageschedule.labelTextDescription')

    //const invalidText = i18n.t('manageschedule.invalidText')
    const schedulePlaceholder = i18n.t('manageschedule.schedulePlaceholder')
    const Select = i18n.t('manageschedule.Select');
    const franchise = i18n.t('manageschedule.franchise');
    const client = i18n.t('manageschedule.client');
    const ApplicationServer = i18n.t('manageschedule.ApplicationServer');
    const technology = i18n.t('manageschedule.technology');
    const AppStack = i18n.t('manageschedule.AppStack');
    
    
    // var rowsArray = [];
    // var rowsClient = [];
    // var rowsTech = [];
    // const [RowsFranchise, setRowsFranchise] = useState([{}]);
    // const [RowsClient, setRowsClient] = useState([{}]);
    // const [RowsTech, setRowsTech] = useState([{}]);

    const sizes = {
        'Extra large size (xl)': 'xl',
        'Default size': undefined,
        'Small size (sm)': 'sm',
    }
    const timeprops = {
        timepicker: () => ({
            pattern: text(
                'Regular expression for the value (pattern in <TimePicker>)',
                '(1[012]|[1-9]):[0-5][0-9](\\s)?'
            ),
            placeholder: text(
                'Placeholder text (placeholder in <TimePicker>)',
                'hh:mm'
            ),
            disabled: boolean('Disabled (disabled in <TimePicker>)', false),
            light: boolean('Light variant (light in <TimePicker>)', false),
            invalid: boolean(
                'Show form validation UI (invalid in <TimePicker>)',
                false
            ),
            invalidText: text(
                'Form validation UI content (invalidText in <TimePicker>)',
                'A valid value is required'
            ),
            maxLength: number('Maximum length (maxLength in <TimePicker>)', 5),
            size: select('Field size (size)', sizes, undefined) || undefined,
            /* onClick: action('onClick'),
             onChange: action('onChange'),
             onBlur: action('onBlur'),*/
        }),
        select: () => ({
            disabled: boolean('Disabled (disabled in <TimePickerSelect>)', false),
            labelText: text(
                'Label text (labelText in <TimePickerSelect>)',
                'Please select'
            ),
            iconDescription: text(
                'Trigger icon description (iconDescription in <TimePickerSelect>)',
                'open list of options'
            ),
        }),
    };


    // const handleChangefranchise = (e) => {
    //     console.log("test...", e.selectedItem.key);
    //     setfranchise(e.selectedItem.key)
    //     // validateForm();
    // }
    // const handleChangeClient = (e) => {
    //     console.log("test...", e.selectedItem.key);
    //     setclient(e.selectedItem.key)
    //     // validateForm();
    // }


    if (user !== null && user.access_token !== null) {
        return (
            <>
                <div className="bx--grid">
                    <div className="bx--row">
                        <div className="bx--col bx--col-sm-4">
                            <TextInput
                                disabled={props.review}
                                id="Schedule"
                                required
                                invalid={props.valid_schedulename}
                                helperText=""
                                invalidText={props.helptext_schedulename}
                                type="text"
                                labelText={ScheduleName}
                                placeholder={schedulePlaceholder}
                                value={props.schedule}
                                onChange={props.handleScheduleChange}
                                onMouseOut={props.handleScheduleChange}

                            />
                        </div>
                        <div className="bx--col bx--col-sm-4">
                            <TextArea placeholder={descriptionPlaceholder}
                                disabled={props.review}
                                id="ScheduleDescription"
                                required
                                invalid={props.valid_scheduledesc}
                                helperText=""
                                type="text"
                                invalidText={props.helptext_scheduledesc}
                                labelText={labelTextDescription}
                                value={props.description}
                                onChange={props.handleDescriptionChange}
                                onMouseOut={props.handleDescriptionChange}
                                />
                        </div>
                    </div>
                </div>

                <div className="margin-bottom-40px">
                    <div className="bx--grid">
                        <div className="bx--row">
                            <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    required
                                    disabled={props.review}
                                    invalid={props.valid_franchisename}
                                    helperText=""
                                    invalidText={props.helptext_franchisename}
                                    ariaLabel="Franchise"
                                    id="franchise"
                                    items={props.RowsFranchise}
                                    titleText={franchise}
                                    label={Select}
                                    onSubmit={props.validateForm}
                                    itemToString={(item) => (item ? item.key : null)}
                                    onChange={({ selectedItem}, e) => props.handleChangefranchise(selectedItem,e)}
                                    selectedItem={props.franchise}
                                    // onMouseOut={({ selectedItem}, e) => props.handleChangefranchise(selectedItem,e)}
                                />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    disabled={props.review}
                                    ariaLabel="Client"
                                    id="client"
                                    invalid={props.valid_clientname}
                                    helperText=""
                                    invalidText={props.helptext_clientname}
                                    items={props.RowsClient}
                                    titleText={client}
                                    label={Select}
                                    itemToString={(item) => (item ? item.key : null)}
                                    onChange={({ selectedItem }) => props.handleChangeClient(selectedItem)}
                                    // onMouseOut={({ selectedItem}, e) => props.handleChangeClient(selectedItem,e)}
                                    selectedItem={props.client}
                                />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    required
                                    disabled={props.review}
                                    ariaLabel="applicationServer"
                                    id="applicationServer"
                                    items={props.RowsApplicationServer}
                                    invalid={props.valid_apphostname}
                                    helperText=""
                                    invalidText={props.helptext_apphostname}
                                    titleText={ApplicationServer}
                                    label={Select}
                                    onSubmit={props.validateForm}
                                    // onMouseOut={({ selectedItem}, e) => props.handleChangeApplicationServer(selectedItem,e)}
                                    onChange={({ selectedItem }) => props.handleChangeApplicationServer(selectedItem)}
                                    selectedItem={props.applicationServer}
                                    itemToString={(item) => (item ? item.key : null)}
                                    
                                />
                            </div>
                           
                            <div className="bx--col bx--col-sm-4">
                                <Dropdown
                                    required
                                    disabled={props.review}
                                    ariaLabel="technology"
                                    id="technology"
                                    items={props.RowsTech}
                                    titleText={technology}
                                    invalid={props.valid_technology}
                                    helperText=""
                                    invalidText={props.helptext_technology}
                                    label={Select}
                                    onChange={({ selectedItem }) => props.handleTechnologyChange(selectedItem)}
                                    // onMouseOut={({ selectedItem }) => props.handleTechnologyChange(selectedItem)}
                                    selectedItem={props.technology}
                                    itemToString={(item) => (item ? item.key : null)} />
                            </div>
                            <div className="bx--col bx--col-sm-4">
                                <MultiSelect.Filterable
                                    {...multiSelectProps}
                                    disabled={props.review}
                                    invalid={props.valid_appstackname}
                                    helperText=""
                                    invalidText={props.helptext_appstackname}
                                    titleText={AppStack}
                                    items={props.RowsAppStack}
                                    itemToString={(item) => (item ? item.appstack_nm : '')}
                                    placeholder={defaultPlaceholder}
                                    translateWithId={(id) => listBoxMenuIconTranslationIds[id]}
                                    selectionFeedback={selectionFeedback}
                                    onChange={({ selectedItems }) => props.onSelectAppstack(selectedItems)}
                                    onMouseOut={({ selectedItem }) => props.onSelectAppstack(selectedItem)}
                                    initialSelectedItems={props.appStack}
                                    invalid={props.valid_appstackname}
                                    invalidText={props.helptext_appstackname}
                                    onMenuChange={(selectedItems) => {
                                        props.onRemoveAppstack(selectedItems);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    } else {
        return (
            <div>
                <h2>{i18n.t('editScheduleRecommendation.please')}<a href={`https://development.aocc-staging-lon02-b3c-7dced0308bf9da27b6e714d1d05f7137-0000.eu-gb.containers.appdomain.cloud/login`}> {i18n.t('editScheduleRecommendation.signup')} </a> </h2>
            </div>
        );
    }



}